const InvoiceStatus = {
    INVOICED: 'invoiced'
};

module.exports = InvoiceStatus;